export default "__VITE_ASSET__B9gd_U6o__"